document.addEventListener('DOMContentLoaded', function() {
  // Tab switching functionality
  const tabButtons = document.querySelectorAll('.tab-button');
  const bookingCards = document.querySelectorAll('.booking-card');

  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      tabButtons.forEach(btn => btn.classList.remove('active'));
      bookingCards.forEach(card => card.classList.remove('active'));

      button.classList.add('active');
      const tabId = button.getAttribute('data-tab');
      const activeCard = document.getElementById(tabId);
      if (activeCard) {
        activeCard.classList.add('active');
      }
    });
  });
});
